import { httpClient } from '../api/http.client';

export interface IntegrationStatus {
  id: string;
  connected: boolean;
  lastSync?: string;
  comingSoon?: boolean;
}

export class IntegrationRepository {
  async getStatus(integrationId: string): Promise<{ connected: boolean; lastSync?: string }> {
    return httpClient.get<{ connected: boolean; lastSync?: string }>(
      `/api/admin/integrations/${integrationId}/status`
    );
  }

  async getAllStatuses(): Promise<IntegrationStatus[]> {
    return httpClient.get<IntegrationStatus[]>('/api/admin/integrations/status');
  }
}

export const integrationRepository = new IntegrationRepository();

